export default {
  'site-title': "Super-vision, the 1st optical marketplace",
  'entete': "Optical supplies:<br><b>ready for the revolution?</b><h2>We are proud to announce the launch of the very first optical supply marketplace in France.</h2>",
  'demande-information': "Information request",
  'plaquette-pdf': "Booklet (pdf)",
  'communique-presse-pdf': "Press release (pdf)",
  'contacter-nous': "<a href=\"mailto:marketplace@super-vision.eu?subject=Marketplace\"><strong>Contact us</strong></a> for more information.",
  'presentation': "<p>Your first goal: increase yours sales.<br> Supervision puts manufacturers and suppliers directly in touch with opticians. <br> We manage communications and help recruit new customers, and then retain.</p><h1 class=\"marg_t15\">SUPERVISION PRESENTS THE 1<sup>st</sup> OPTICAL MARKETPLACE</h1>",
  'sans-abo': "<h2>NO SUBSCRIPTION</h2><p>Access over 10,000 customers <br> in one click</p>",
  'experience': "<h1 class=\"left\">7</h1><p class=\"left\"><strong>YEARS</strong><br> of e-Commerce<br> experience</p>",
  'nb-client': "<h1><span style=\"font-size: 90px; line-height: 0.6em; font-weight: 600;\">+</span><br><span class=\"right\">10 000</span></h1><p class=\"right\"><strong>opticians are already customers</strong></p>",
  'nb-commande': " <h1><span style=\"font-size: 90px; line-height: 0.6em; font-weight: 600;\">+</span><br><span class=\"right\">700</span></h1><p class=\"right\"><strong>orders per day</strong></p>",
  'revolution': "<h2>With you</h2><p>The optical revolution<br> is on the way!</p>",
  'nouveau-canal': "<h2>A NEW ADDITIONAL DISTRIBUTION CHANNEL</h2><p>manage your orders, confirm shipments and communicate with your customers.</p>",
  'plateforme': "<h2>ACCESS A POWERFUL PLATFORM</h2><p>on which you can quickly and efficiently display your products, your stock and your sales policy. In just a few days, you'll start making sales.</p>",
  'reference': "<h2>BEING LISTED</h2><p>on Supervision is a guarantee of quality, reliability and know-how.<br><strong>Offer, sell, retain!</strong></p>",
  'autonomie': "<h2><strong>KEEP FULL CONTROL</strong> <br> OF YOUR SALES POLICY</h2><p>based on your goals and business strategy, you decide which markets you want to be present on: you have TOTAL freedom.</p>",
  'simple-intuitif': "<h1>SIMPLE AND INTUITIVE</h1><div class=\"ligne\"></div><p>The B2B Supervision marketplace has been developed by specialist platform designers. We use unique, ground-breaking technology for an easy user-friendly experience.</p>",
  'unique': "<h1>UNIQUE IN FRANCE</h1><div class=\"ligne\"></div><ul class=\"bullets\"><li>Our customers become your customers.</li><li>Communicate with more than 10 000 opticians in one click.</li><li>Test your offers and your communication.</li></ul>",
  'garantie': "<h1>We guarantee you have complete control of your sales policy:</h1><div class=\"ligne\"></div><ul class=\"bullets\"><li>Select the products you want to list on Supervision.</li><li>Set your prices - at any time.</li><li>Apply your own sales policy and promotions.</li></ul>",
  'rejoignez-maintenant': "<h1>Join tomorrow's<br>BtoB optical supply platform now</h1><p>For further information , please fill the information form</p><em>(<span class=\"textrouge\">*</span>) required field.</em>",
  'info-contact': "Your contact information",
  'nom': "First name",
  'prenom': "Last name",
  'telephone': "Telephone",
  'email': "E-mail",
  'raison-sociale': "Company name",
  'info-societe': "Company information",
  'adresse': "Number and street",
  'code-postal': "Zip code",
  'ville': "City",
  'pays': "Country",
  'domaine-activite': "Activities",
  'marques-concernees': "Brands concerned",
  'pays-expedition': "Your country of consignment",
  'envoyer': "Send",
  'copyright': "Copyright © 2017 <strong>Super-vision</strong>. All rights reserved. Build by <a href=\"http://www.boostup.fr\" target=\"_blank\"><strong>Boostup</strong></a>",
  'categories-produit': "Products categories",
  'compteur': "The revolution begins in",
  'jours': "days",
  'heures': "hours",
  'minutes': "min",
  'secondes': "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sec",
  'verre': "Prescription lenses",
  'montures': "Frames",
  'montures_solaires': "Sunglasses",
  'lentilles': "Contact lenses",
  'solutions': "Lenscare",
  'instruments_optique_mesure': "Optical instruments",
  'basse_vision': "Low vision",
  'accessoires_lunettes': "Accessories frames",
  'materiel_outillage': "Tools",
  'montage_reparation': "Repairs",
  'informatique': "IT , software",
  'agencement_magasin': "Equipment stores",
  'services': "Services",
  'autres': "Others",
  'success': "Send successfully, thank you for your confidence !",
  'error': "Oops! An error has occurred please try again later.",
  'invalide': "Please fill in all required fields"
};


// WEBPACK FOOTER //
// ./src/traduction/en.ts